
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import EmployeeService from "../../services/resource/employeeService";
import LOGO from '../../assets/york.png'
import InputForm from "../../components/input/input";

import './styles.css'
import ButtonLoading from "../../components/buttonLoading/buttonLoading";

function AlterarSenha() {
    const service = new EmployeeService();
    const { id, codigo } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [error, setError] = useState('');

    const resetPassword = (event) => {
        event.preventDefault();

        service.resetPassword({
            id: id,
            newPassword: password,
            verificationCode: codigo,
        }).then(() => {
            toast.success("Senha alterada com sucesso, você já pode realizar login com nova senha!");
            navigate('/login');
        }).catch(() => {
            setError("Erro ao modificar senha")
        })
    };

    return (
        <div style={{height:'100vh'}} className="flex items-center justify-center px-4">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <div className="flex justify-center mb-6">
                    <img src={LOGO} alt="LOGO YORK" className="h-12 w-auto" />
                </div>

                <form onSubmit={resetPassword} className="space-y-5">
                    <div>
                        <InputForm
                            id="password"
                            type="password"
                            name="password"
                            label="Senha"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div>
                        <InputForm
                            id="passwordRepeat"
                            type="password"
                            name="passwordRepeat"
                            label="Repita nova senha"
                            value={passwordRepeat}
                            onChange={(e) => setPasswordRepeat(e.target.value)}
                        />
                    </div>

                    {error && (
                        <p className="text-sm text-red-600 mt-1">{error}</p>
                    )}

                    <div className="flex justify-center">
                        <ButtonLoading
                            type="submit"
                            disabled={
                                (!password && !passwordRepeat) || password !== passwordRepeat
                            }
                            color="indigo"
                            label="Alterar Senha"
                        >
                            ALTERAR SENHA
                        </ButtonLoading>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AlterarSenha;